import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageTitle from "../../../../components/pageTitle";
import { handleAllUsers, resetAllSummeryData } from "../../../../redux/actoin";
import { API } from "../../../../scripts/api";
import axiosInstance from "../../../../scripts/axiosInspector";
import CreateUser from "./form";

const CreateCustomer = () => {
  const [data, setData] = useState({});
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const AllUsers = useSelector((state) => state.AllUsers);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSumbit = () => {
    setLoadingSubmit(true);
    axiosInstance
      .post(
        API.info.customerSingle,
        {
          ...data,

          guidStateRecNo: company?.guidRecNo,
        },
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        if (res?.data?.isSuccess) {
          dispatch(resetAllSummeryData());

          if (AllUsers.users?.page) {
            axiosInstance
              .get(
                API.info.customerItem +
                  `?guidStateRecNo=${company?.guidRecNo}&guidRecNo=${res?.data.data}`,
                {
                  headers: {
                    Authorization: `Bearer ${userInfo?.token}`,
                    "Cache-Control": "no-cache",
                    Pragma: "no-cache",
                    Expires: "0",
                    "Accept-Language": "fa-IR",
                    chHostName: process.env.REACT_APP_CHHOSTNAME,
                  },
                }
              )
              .then((res) => {
                var temp = [...AllUsers.users?.customers];
                temp.unshift(res?.data?.data);
                dispatch(
                  handleAllUsers({
                    ...AllUsers.users,
                    customers: temp,
                  })
                );
                navigate("/sell/customer");

                toast.success(res?.data?.message);
              })
              .catch((err) => {
                toast.error(res?.data?.message);
              });
          } else {
            navigate("/sell/customer");
            toast.success(res?.data?.message);
          }
        } else {
          toast.error(res?.data?.message);
        }
        setLoadingSubmit(false);
      })
      .catch((err) => {
        toast.error("خطایی رخ داده است مجدد تلاش کنید");
        setLoadingSubmit(false);
        /*         if (err.response.status === 401 || err.response.status === 403) {
          dispatch(handleLogOut());
        } */
      });
  };
  useEffect(() => {
    axiosInstance
      .get(API.info.buyerLast + `?guidStateRecNo=${company?.guidRecNo}`, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        setData({ ...data, chSaleSoftID: res.data.data.chNextSaleSoftID });
      })
      .catch((err) => {});
  }, []);
  return (
    <>
      {" "}
      <PageTitle
        broadCrumb={[
          {
            title: "فروش",
            path: "/sell",
          },
          {
            title: "خریداران",
            path: "/sell/customer",
          },
        ]}
        title={"ساخت خریدار"}
      />
      <CreateUser
        data={data}
        setData={setData}
        handleSumbit={handleSumbit}
        loadingSubmit={loadingSubmit}
      />
    </>
  );
};

export default CreateCustomer;
